import React, { useReducer, useState } from 'react';
import { Item } from '../../utils/sharedTypes';
import { DepartmentFilter } from '../departments/departmentsTypes';
import DepartmentsOptionsBar from '../departments/DepartmentsOptionsBar';
import DepartmentsTable from '../departments/DepartmentsTable';
import DepartmentsFilterBar from '../departments/DepartmentsFilterBar';
import clsx from 'clsx';
import useStyles from '../orders/orderLinkedItemsStyles';
import { Button, Grid } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import PlansLinkedItemsDisplay from './PlansLinkedItemsDisplay';

const initialFilters: DepartmentFilter = {
  companyName: '',
  departmentName: '',
  timeToExpiration: '',
};

const SupportPlans = () => {
  const classes = useStyles();
  const [filters, setFilters] = useReducer(
    (curVals: DepartmentFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedDepartments, setSelectedDepartments] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  return (
    <div
      className={clsx(classes.content, {
        [classes.contentShift]: sidebarOpen,
      })}
    >
      <DepartmentsFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container justifyContent='space-between'>
        <Grid container item xs spacing={2}>
          <Grid item>
            <DepartmentsOptionsBar
              selectedDepartments={selectedDepartments}
              setSelectedDepartments={setSelectedDepartments}
              editModalOpenFlag={editModalOpenFlag}
              setEditModalOpenFlag={setEditModalOpenFlag}
              company={null}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Button
            color='primary'
            className={clsx(sidebarOpen && classes.hide)}
            onClick={() => {
              setSidebarOpen(true);
            }}
            endIcon={<ChevronLeft />}
          >
            Plan Details
          </Button>
        </Grid>
      </Grid>
      <DepartmentsTable
        setSelectedDepartments={setSelectedDepartments}
        filters={filters}
        setEditModalOpenFlag={setEditModalOpenFlag}
        supportPage={true}
      />
      <PlansLinkedItemsDisplay
        departments={selectedDepartments}
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        companyId={
          selectedDepartments[0]?.companyId
            ? Number(selectedDepartments[0].companyId)
            : -1
        }
      />
    </div>
  );
};

export default SupportPlans;
